<template>
  <div id="main">
    <div class="main clearfix">
      <div class="mainconn mainConn1">
        <div class="mainRConn">
          <div class="mainRConnBox mainRConn1">
            <table class="mainRTable mainRTable1">
              <thead>
                <tr>
                  <td>排名</td>
                  <td></td>
                  <td>公司名称</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in companyList" :key="index">
                  <td>{{item.sort >3 ?item.sort : ""}}</td>
                  <td class="bxcpLOGO">
                    <img :src="item.logo" />
                  </td>
                  <td>{{item.name}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyList: []
    };
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      this.axios.get("App.quarter.action").then(result => {
        this.companyList = result.data.success;
      });
    }
  }
};
</script>

<style scoped>
.main {
  position: relative;
  margin: 0 auto;
  width: 1100px;
  padding: 50px 0 120px;
}
.mainConn1 {
  width: 600px;
  float: left;
  margin-left: 160px;
}

.mainRConn,
.mainRConnBox {
  width: 100%;
}

.mainRConn table {
  width: 100%;
  text-align: center;
  color: #373737;
  font-size: 16px;
  -table-layout: fixed;
}

.mainRConn table thead {
  font-weight: bold;
}

.mainRConn table thead tr {
  height: auto;
}

.mainRConn table tr {
  height: 120px;
}

.mainRConn table tr td:first-child {
  width: auto;
}

.mainRConn table tbody tr {
  cursor: pointer;
}

.mainRConn table tbody tr:first-child td:first-child {
  background: url(../../images/bxcp_level1.png) no-repeat center;
}

.mainRConn table tbody tr:nth-child(2) td:nth-child(1) {
  background: url(../../images/bxcp_level2.png) no-repeat center;
}

.mainRConn table tbody tr:nth-child(3) td:nth-child(1) {
  background: url(../../images/bxcp_level3.png) no-repeat center;
}

.bxcpLOGO img {
  width: 80px;
}

.bxcpName {
  width: 230px;
  -text-align: left;
}

.mainRConnBox ul {
  display: none;
}
@media screen and (min-width: 100px) and (max-width: 768px) {
  .main {
    width: 100%;
    padding: 20px 0 0;
  }
  .mainConn1 {
    width: 100%;
    margin: 0;
  }
  .mainLTab,
  .mainRConn {
    float: none !important;
  }
  .main .mainLTab {
    height: 30px;
    margin: 8px 0;
    text-align: center;
    width: 100%;
    background: none;
  }
  .main .mainLTab ul {
    width: 100%;
    text-align: center;
  }
  .main .mainLTab ul li {
    float: none;
    display: inline-block;
    width: 23.5%;
    margin-right: 0px;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    background: #fff;
  }
  .main .mainLTab ul li:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .main .mainLTab ul li:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .main .mainRConn,
  .mainRConnBox {
    background: #fff;
    width: 100%;
  }
  .mainRConnBox ul {
    display: block;
  }
  .mainRConnBox ul li {
    height: 75px;
    padding: 15px 0;
    margin-bottom: 2px;
    overflow: hidden;
  }
  .mainRConnBox ul li .bxcpLOGO {
    width: 23%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .mainRConnBox ul li .bxcpLOGO img {
    width: 70%;
    vertical-align: middle;
  }
  .mainRConnBox ul li .bxcpListConn {
    width: 54%;
  }
  .mainRConnBox ul li .bxcpName {
    line-height: 20px;
    font-size: 15px;
    width: 100%;
    margin-bottom: 10px;
    height: 40px;
  }
  .mainRConnBox ul li .companyName {
    font-size: 14px;
    color: #797979;
  }
  .mainRConnBox ul li .bxcpStar {
    width: 23%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .mainRConnBox ul li .bxcpStar img {
    height: 20%;
  }
  #main {
    margin-bottom: 20px;
  }
  .mainRTable {
    display: table;
    border-collapse: collapse;
  }
  .mainRTable thead {
    display: none;
  }
  .mainRConn table tbody {
    width: 100%;
  }
  .mainRConn table tbody tr {
    height: 100px;
  }
  .mainRConn table tbody td {
    border-bottom: 1px solid #e7e7e7;
    line-height: 0;
  }
  .mainRConn table tr td:first-child {
    width: 30%;
  }
  .mainRConn table tr td:nth-child(2) {
    width: 30%;
  }
  .mainRConn table tr td:nth-child(2) img {
    width: 66%;
  }
  .mainRConn table tr td:nth-child(3) {
    width: 40%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/itemList/quarterlyList.vue